import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import paytm from "../../images/home/client/paytm.svg";
import neosoft from "../../images/home/client/neosoft.svg";
import Toyota from "../../images/home/client/Toyota.svg";
// import matellio from '../../images/home/client/matellio.svg';
import tredence from "../../images/home/client/tredence.png";
// import celebal from '../../images/home/client/celebal.png';
import publicissapient from "../../images/home/client/publicissapient.svg";
// import speridian from '../../images/home/client/speridian.png';
import nbc from "../../images/home/client/nbc.svg";
import lessmeeting from "../../images/home/client/lessmeeting.png";
import cybersiara from "../../images/home/client/cybersiara.svg";
import walmart from "../../images/home/client/walmart.svg";
import GifTap from "../../images/home/client/GifTap.png";
import bloom from "../../images/home/client/bloom.png";

const ClientLogo = {
  nav: false,
  loop: true,
  margin: 70,
  dots: false,
  autoplay: true,
  autoplaySpeed: 2200,
  autoplayTimeout: 2200,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1,
    },
    481: {
      items: 2,
    },
    576: {
      items: 3,
    },
    768: {
      items: 4,
    },
    992: {
      items: 5,
    },
  },
};

const partnerLogo = [
  {
    images: paytm,
  },
  {
    images: neosoft,
  },
  {
    images: Toyota,
  },
  {
    images: walmart,
  },
  {
    images: bloom,
  },
  {
    images: tredence,
  },
  {
    images: publicissapient,
  },
  {
    images: nbc,
  },
  {
    images: lessmeeting,
  },
  {
    images: cybersiara,
  },
  {
    images: GifTap,
  },
];

const Client = () => {
  return (
    <>
      <section className="hireClientSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading" data-aos="slide-right">
                <h3>
                  Trusted By <span>Top Customers</span>
                </h3>
                <p>Our true value can be perceived by our customers!</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <OwlCarousel className="owl-carousel owl-theme" {...ClientLogo}>
                {partnerLogo.map((each, i) => (
                  <div className="item" data-aos="zoom-in" key={i}>
                    <img src={each.images} alt="Hire Dedicated Resources" />
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Client;
